import React, { useState, useEffect } from 'react';
import { PRICING_PLANS } from '../../utils/constants';
import '../../styles/components/PricingSection.css';

const PricingSection = () => {
  const [isYearlyBilling, setIsYearlyBilling] = useState(true);
  const [couponColor, setCouponColor] = useState('green');
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleBillingChange = (yearly) => {
    setIsYearlyBilling(yearly);
    setCouponColor(yearly ? 'green' : 'red');
  };

  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-container">
        <div className="pricing-header">
          <h2 className="pricing-title">
            Launch and scale your Amazon and TikTok Shop business
          </h2>
          
          {/* Billing Toggle - Mobile Optimized */}
          <div className="billing-toggle">
            <button
              className={`toggle-button ${!isYearlyBilling ? 'active' : ''}`}
              onClick={() => handleBillingChange(false)}
              aria-pressed={!isYearlyBilling}
            >
              Monthly
              {!isMobile && <span> Billed monthly</span>}
            </button>
            <button
              className={`toggle-button ${isYearlyBilling ? 'active' : ''}`}
              onClick={() => handleBillingChange(true)}
              aria-pressed={isYearlyBilling}
            >
              Yearly
              {!isMobile ? (
                <span style={{ marginLeft: '0.25rem' }}>
                  <span style={{ color: '#059669' }}> (Save 25%)</span>
                </span>
              ) : (
                <span style={{ color: '#059669', marginLeft: '0.25rem' }}>25%</span>
              )}
            </button>
          </div>
          
          {/* Coupon Code Banner - Mobile Optimized */}
          <div className={`coupon-banner ${couponColor}`}>
            <div className="coupon-content">
              <div className="coupon-info">
                <span className="coupon-code">25BFCM350FF12M</span>
                <span className={`coupon-status ${couponColor}`}>
                  {couponColor === 'red' ? '✗ Not applicable' : '✓ Applied'}
                </span>
              </div>
              <button className="apply-button">Apply</button>
            </div>
            <p className={`coupon-message ${couponColor}`}>
              {couponColor === 'red' 
                ? 'Coupon only valid for yearly plans!' 
                : '35% off for 12 months!'}
            </p>
          </div>
        </div>
        
        {/* Pricing Cards Grid - Mobile Optimized */}
        <div className="pricing-cards">
          {PRICING_PLANS.map((plan) => (
            <div 
              key={plan.id} 
              className={`pricing-card ${plan.popular ? 'popular' : ''}`}
            >
              {plan.popular && (
                <div className="popular-badge">
                  Most Popular
                </div>
              )}

              <div className="card-header">
                <h3 className="card-title">{plan.name}</h3>
                <p className="card-tagline">{plan.tagline}</p>
              </div>

              <div className="card-price">
                <div className="price-container">
                  <span className="price-currency">$</span>
                  <span className="price-amount">
                    {isYearlyBilling ? plan.yearlyPrice : plan.monthlyPrice}
                  </span>
                </div>
                <span className="price-period">
                  {isYearlyBilling ? '/month (billed yearly)' : '/month'}
                </span>
              </div>

              <ul className="features-list">
                {plan.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <svg className="check-icon" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>

              <button 
                className={`card-button ${plan.popular ? 'primary' : 'secondary'}`}
                aria-label={`Get started with ${plan.name} plan`}
              >
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>

        {/* Mobile Only: FAQ Link */}
        {isMobile && (
          <div className="mobile-faq">
            <p className="faq-text">Have questions about pricing?</p>
            <a href="#faq" className="faq-link">
              View FAQ →
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default PricingSection;